export enum DataPointEnum {
    digitalChannel1 = 1601,
    digitalChannel2,
    analog1AC,
    analog1DC,
    analog1InstantOff,
    analog2AC,
    analog2DC,
    analog2InstantOff,
    analog3AC,
    analog3DC,
    analog3InstantOff,
    analog4AC,
    analog4DC,
    analog4InstantOff,
    analog1AcHigh,
    analog1AcLow,
    analog1DcHigh,
    analog1DcLow,
    analog2AcHigh,
    analog2AcLow,
    analog2DcHigh,
    analog2DcLow,
    analog3AcHigh,
    analog3AcLow,
    analog3DcHigh,
    analog3DcLow,
    analog4AcHigh,
    analog4AcLow,
    analog4DcHigh,
    analog4DcLow,
    digitalInput5,
    digitalInput6,
    instantOff = 1654,
    digitalAccumulator1 = 1655,
    digitalAccumulator2 = 1656,
    analog5AC = 1832,
    analog5DC = 1833,
    analog6AC = 1834,
    analog6DC = 1835,
    analog7AC = 1836,
    analog7DC = 1837,
    analog8AC = 1838,
    analog8DC = 1839,
    analog9AC = 1840,
    analog9DC = 1841,
    analog10AC = 1842,
    analog10DC = 1843,
    analog11AC = 1844,
    analog11DC = 1845,
    analog12AC = 1846,
    analog12DC = 1847,
    analog13AC = 1848,
    analog13DC = 1849,
    analog14AC = 1850,
    analog14DC = 1851,
    analog15AC = 1852,
    analog15DC = 1853,
    analog16AC = 1854,
    analog16DC = 1855
}
